import { render, staticRenderFns } from "./taskDetail.vue?vue&type=template&id=db8fbdf0&scoped=true&"
import script from "./taskDetail.vue?vue&type=script&lang=js&"
export * from "./taskDetail.vue?vue&type=script&lang=js&"
import style0 from "./taskDetail.vue?vue&type=style&index=0&id=db8fbdf0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db8fbdf0",
  null
  
)

export default component.exports